module.exports = __webpack_public_path__ + "static/media/job_completed.fe7bade3.svg";